/* @ngInject */
export default function SideMenuCacheService() {
    this.sidemenu = [];
}
